// extracted by mini-css-extract-plugin
export var avatarContainer = "_gt-0";
export var avatarTypingWave = "_gt-i";
export var gray = "_gt-f";
export var green = "_gt-c";
export var icon = "_gt-9";
export var image = "_gt-1";
export var lg = "_gt-6";
export var md = "_gt-5";
export var presenceDot = "_gt-b";
export var red = "_gt-d";
export var sm = "_gt-4";
export var status = "_gt-a";
export var typingDot = "_gt-h";
export var typingPill = "_gt-g";
export var xl = "_gt-7";
export var xs = "_gt-3";
export var xxl = "_gt-8";
export var xxs = "_gt-2";
export var yellow = "_gt-e";